/**
 * CoinMatch活动配置
 */
class CoinMatchConfig {
    constructor() {
        this.inited = false;
    }
    
    init(config, layout) {
        tableToArray(layout);
        Object.assign(this, layout);

        let levelIds = [];
        for(let i = 1, v = config.level_array[i]; v != null; i++, v = config.level_array[i]) 
            levelIds.push(v);

        let rewards = {}
        for(let i = 0; i < levelIds.length; i++) {
            let obj = config["level_"+(i+1)+"_reward"];
            let keys = obj == null? null: Object.keys(obj);
            if (keys != null && keys.length > 0)
                rewards[i] = { itemId: keys[0], num: obj[keys[0]] };
        }

        this.values = {
            startTime: config["start_time"],
            endTime: config["end_time"],
            totalCoin: config["total_coin"],    // 单位：万
            levelIds: levelIds,
            levelRewards: rewards,
            inviteMax: config["total_invite_count"],
            adStep: config["ad_reward"],
            adLimit: config["ad_limit"],
            attendHoursCounts : config["attendpeople_hours_count"],
            stepLack: config["step_lack"],
            adLevelLimit: config["ad_level_limit"],
            adLevelStep: config["ad_level_reward"],
            lvWeight: config["progress_display"],
            askforhelp_duration: config["askforhelp_duration"],
            askforhelp_succeed: config["askforhelp_succeed"],
            shareJudgeTime: config["askforhelp_timer"]
        };

        this.strings = {
            name: getText("coin.match.name"),
            period: getText("jigsaw.panel.timerange", { endtime: formatTime2Str2(config["end_time"] * 1000) }),
            posterStart: getText("coin.match.poster.start"),
            posterReward: getText("coin.match.poster.reward", { total: this.values.totalCoin }),
            finalGain: getText("coin.match.reward.gain"),
            quesTitle: getText("clover.text.565"),
            quesSure: getText("clover.text.228"),
            quesContent: getText("coin.match.introduction"),
            reward: getText("coin.match.description.reward", { total: this.values.totalCoin }),
            rewardPeriod: getText("coin.match.reward.period", { from: formatTime2Str2((config["end_time"] + 1) * 1000), end: formatTime2Str2(config["reward_end_time"] * 1000) }),
            passAll: getText("coin.match.passall"),
            enter: getText("coin.match.nextlevel"),
            enterImm: getText("coin.match.imm"),
            adTip: getText("coin.match.adtext"),
            inviteReceive: getText("coin.match.invite.receive"),
            inviteReceived: getText("coin.match.invite.received"),
            inviteStepSuccess: getText("coin.match.invite.step.success"),
            adStepSuccess: getText("coin.match.ad.step.success"),
            resetTip: getText("coin.match.reset.desc", {num: config["reset_step"]}),
            quitContent: getText("coin.match.quit.content"),
            openFail: getText("panel.error.open.default"),
            resetSuccess: getText("coin.match.reset.success"),
            resetAdQuit: getText("coin.match.reset.adquit"),
            stepLack: getText("coin.match.entrytips"),
            stepZero: getText("coin.match.entryfailed"),
            adQuit: getText("video.tip.quit")
        };

        this.permanentResList = [];
        this.inited = true;

        console.log("CoinMatchConfig init Success", this, config);
    }

    getLevelStr(passStep) {
        return getText("coin.match.level", {level: passStep});
    }
    
    getBoxLevelStr(lvStep) {
        return getText("coin.match.box.level", {level: lvStep});
    }

    getFailedStr(lvRemain) {
        return lvRemain == 0? getText("coin.match.failedtext.final"): getText("coin.match.failedtext", {level: lvRemain});
    }

    getSuccessStr(lvStep) {
        return getText("coin.match.succeedtext1", {level_id: lvStep});
    }
}

function tableToArray(obj) {
    let keys = Object.keys(obj);
    if (keys.length > 0) {
        keys.forEach((key)=> {
            if (obj.hasOwnProperty(key)) {
                let child = obj[key];
                if(child != null) {
                    if (typeof child == "object") {
                        if (child instanceof Array) 
                            obj[key] = $tableToArray(child);
                        tableToArray(child); 
                    }   
                }
            }
        });
    }
}

let config = new CoinMatchConfig()
module.exports = config